<template>
  <div class="dq-gs-page-hero">
    <div class="d-flex align-items-start gap-3">
      <div class="dq-gs-hero-icon" :class="toneClass">
        <i :class="icon"></i>
      </div>
      <div>
        <h4 class="mb-1 fw-semibold">{{ title }}</h4>
        <p v-if="subtitle" class="text-muted mb-0 small">{{ subtitle }}</p>
      </div>
    </div>
    <div v-if="$slots.aside" class="text-md-end">
      <slot name="aside" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: "" },
  icon: { type: String, default: "ti ti-settings" },
  tone: {
    type: String,
    default: "primary",
    validator: (v) => ["primary", "indigo", "amber", "teal"].includes(v),
  },
});

const toneClass = computed(() => `tone-${props.tone}`);
</script>
